import styled from 'styled-components';

import { Icon } from '@column/column-ui-kit';

export const AccessIconDefault = styled(Icon.Settings)`
  --icon-color: ${({ theme }) => theme.gray.blendToBackground(600)} !important;
`;

export const AccessIconNoAccess = styled(Icon.Close)`
  --icon-color: ${({ theme }) => theme.red.background} !important;
`;

export const AccessIconViewOnly = styled(Icon.Eye)`
  --icon-color: ${({ theme }) => theme.primary.background} !important;
`;

export const AccessIconEdit = styled(Icon.Edit)`
  --icon-color: ${({ theme }) => theme.yellow.background} !important;
`;

export const AccessIconFullAccess = styled(Icon.CircleCheck)`
  --icon-color: ${({ theme }) => theme.seafoam.background} !important;
`;

export const AccessIconCustom = styled(Icon.Filters)`
  --icon-color: ${({ theme }) => theme.yellow.background} !important;
`;
